import { startLocalRuntime } from "./localRuntime";
import { initializeReaderSession } from "./readerSession";
import { showBootError } from "./lib/bootError";

async function boot(): Promise<void> {
  const reader = await initializeReaderSession();
  if (reader === null) return;
  await startLocalRuntime(reader.id);
  // Bundled dev can move UI code into shared chunks. Load it only after this entry runs
  // the React refresh preamble, and catch failures before React mounts.
  const { startup } = await import("./main");
  await startup;
}

void boot().catch(showBootError);
